import type { FlagConfiguration } from '@atlassian/jira-flags/src/services/types'; // ignore-for-ENGHEALTH-17759
import messages from './messages.tsx';

export const CREATE_FAILED_FLAG: FlagConfiguration = {
	type: 'error',
	title: messages.createErrorTitle,
	description: messages.createErrorMessage,
	messageType: 'transactional',
};

export const QUERY_NAME = 'jwmCreateCategory';
